import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

import Header from './components/Header';
import HeroCarousel from './components/HeroCarousel';
import Welcome from './components/Welcome';
import ProductShowcase from './components/ProductShowcase';
import Morotsmejeriet from './components/Morotsmejeriet';
import WhyWe from './components/WhyWe';
import PDFSection from './components/PDFSection';
import Footer from './components/Footer';

// Pages
import ProductsPage from './pages/ProductsPage';
import MarketsPage from './pages/MarketsPage';
import ContactPage from './pages/ContactPage';
import PricePage from './pages/PricePage';
import ImagesPage from './pages/ImagesPage';
import StorhandlaPage from './pages/StorhandlaPage';
import ImprintPage from './pages/ImprintPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

import './App.css';

function App() {
  return (
    <HashRouter>
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-grow">
          <AnimatePresence mode="wait">
            <Routes>
              <Route
                path="/"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    <HeroCarousel />
                    <Welcome />
                    <ProductShowcase />
                    <WhyWe />
                    <Morotsmejeriet />
                    <PDFSection />
                  </motion.div>
                }
              />
              <Route path="/produkter" element={<ProductsPage />} />
              <Route path="/marknader" element={<MarketsPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/aktuella-priser" element={<PricePage />} />
              <Route path="/bilder" element={<ImagesPage />} />
              <Route path="/storhandla" element={<StorhandlaPage />} />
              <Route path="/imprint" element={<ImprintPage />} />
              <Route path="/integritetspolicy" element={<PrivacyPolicyPage />} />
              {/* Fallback route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;